import { sharedColors } from "ui/theme/colors"

const colors = {
  ...sharedColors,
  propBlue: "#89C744",
  heroBackgroundEn: "#fff",
  heroBackgroundHe: "#fff",
  heroTextColor: "#000",
  heroSvgIconColor: "rgba(137, 199, 68, 1)",
  filterModalHeaderColor: "#89C7440D",
  filterModalHeaderTextColor: "#000",
  footerColor: "#A2C900",
  socialColor: "#000",
  footerTextColor: "#000",
  footerHRColor: "#000",
  navBackgroundColor: "white",
  navTextColor: "black",
  selectedNavTextColor: "#89C744",
  selectedSubNavTextColor: "#89C744",
  selectedMobileNavTextColor: "#89C744",
  footerSocialsBackgroundColor: "#A2C900",
  footerLogoLinkBackgroundColor: "white",
  numberGridBackgroundColorEn: "linear-gradient(90deg, #89C744 0%, #62902E 100%)",
  numberGridBackgroundColorHe: "linear-gradient(90deg, #62902E 0%, #89C744 100%)",
  numberGridBorderColor: "rgba(137, 199, 68, 1)",
  numberGridTextColor: "black",
  newNumberGridTextColor: "black",
  accordionPanelBackgroundColor: "rgba(137, 199, 68, 0.4)",
  jobsQuoteGalleryBackgroundColor: "rgba(137, 199, 68, 1)",
  jobsQuoteGalleryBulletColor: "black",
  jobsGalleryItemTextColor: "black",
  teamContainerBackgroundColor: "rgba(137, 199, 68, 1)",
  teamContainerTextColor: "black",
  buttonHoverBackgroundColor: "#89C744",
  buttonActiveBackgroundColor: "#89C744",
  buttonHoverTextColor: "black",
  paginationBackgroundColor: "#89C744",
  paginationTextColor: "white",
  bulletsBackgoundColor: "#89C744",
  faqTextColorExpanded: "#FFF",
  faqTextColorHover: "#FFF",
  faqRootBackground: "linear-gradient(90deg, #89C744 0%, #62902E 100%)",
  faqRootInsideBackground: "white",
  faqRootInsideBackgroundHover: "white",
  faqRootInsideColorHover: "black",
  faqBorderColor: "#89C744",
  faqTextColor: "#FFF",
  faqIconColor: "#89C744",
  faqIconColorAlternative: "#FFF",
  faqBoxShadow: "0px 4px 12px 0px rgba(0, 0, 0, 0.08)",
  faqTitleBorderBottom: "#89C744",
  heroBgFallback: "#A2C900",
}

export default colors
